import React from 'react';
import { HashLoader } from 'react-spinners';

import styles from '../../css/admin/LazySpinner.module.css';
const LazySpinner = () => {
  return (
    <div className={styles.lazySpinner}>
      <HashLoader color="#8AAAE5" />
    </div>
  );
};

export default LazySpinner;
